module.exports = __webpack_public_path__ + "img/close.be08a241.png";